export default {
  views: {
    product: {
      description:
        '东京晴空塔展望台入场券和东京索拉玛奇与并设的水族馆入场券组合而成的实惠门票。',
      plans: {
        title: '选择套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      panels: {
        selectDate: '选择日期',
        selectPlan: '选择套餐',
        selectPeople: '选择人数',
        options: '附加商品',
        profile: '个人资料'
      },
      auth: {
        loginOrRegister: '登录 / 注册',
        signUpTip: '请输入您的信息以注册'
      },
      calendar: {
        priceNote: '※显示价格为当日成人票价'
      },
      recommendations: {
        title: '推荐商品'
      }
    },
    book: {
      title: '订单确认',
      bookingNotice: '请在预订前确认',
      paymentConfirmation: '请在支付前确认',
      tip: '请尽快完成操作，以确认订单'
    },
    bookConfirm: {
      paymentInfo: '支付信息',
      paymentConfirmation: {
        warningTitle: '请确认取消政策：',
        warningText: '该商品一旦购买将无法退款。',
        agreementText: '我已确认并同意'
      },
      prePaymentConfirmation: {
        title: '支付前确认事项',
        checkInput: '请确认输入内容是否正确。',
        emailNotice:
          '注意：如果您设置了域名邮件过滤，请在预约前将"@linktivity.co.jp"添加到白名单。',
        agreementText: '我已确认并同意上述事项。'
      },
      paymentAmount: {
        total: '支付金额（含税）',
        details: '详细',
        note: '日元以外的币种金额为依据当前汇率计算的预估金额，与实际扣款金额可能略有差异，仅供参考。'
      },
      participantInfo: {
        title: '代表者信息',
        dialogTitle: '修改代表者信息',
        change: '变更',
        password: '密码',
        validation: {
          passwordRequired: '请输入密码'
        }
      },
      actionButtons: {
        back: '返回',
        toPayment: '去支付'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '凭证'
    },
    bookingDetail: {
      title: '预订详情',
      detailInfo: '预订详情',
      startDate: '参加日期',
      validityPeriod: '有效期',
      voucherInfo: '凭证',
      digitalTicket: '电子票',
      invoice: '收据/发票',
      invoiceSend: '开具',
      invoiceSent: '发票已开具',
      redemption: '使用电子票',
      meetingPoint: '入场位置指南',
      beforeTrip: '使用前确认事项',
      bookingAction: '预订操作',
      cancelBooking: '取消预订',
      cancelConfirmPolicy: '请确认取消政策：',
      customerName: '预订人',
      actualPayment: '支付金额',
      refundAmount: '退款金额',
      orderId: '预订ID',
      orderCompletionTime: '预订时间',
      digitalTicketValidPeriod: 'QR码仅在使用当天有效',
      digitalTicketWaiting: '*订单确认后，电子票将在此显示',
      sending: '发送中...',
      sendToEmail: '发送至邮箱',
      cancelConfirm: '是否确认取消预订？',
      cancelFee: '取消费用',
      cancelRemarkSelect: '请选择取消原因',
      inclusion: '包含的物品',
      checklist: '注意事项',
      restrictions: '参加制限',
      requirements: '参加前・参加时必要事项',
      attireItems: '参加时必要服装・持物',
      otherInfo: '备注・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '图片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '变更预订日期或人数',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '误订',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重复预订',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延误或变更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有变',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改订为其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    components: {
      selectOption: {
        title: '附加商品',
        quantity: '数量: {{quantity}}',
        addCart: '加入购物车',
        timeSelect: '选择时间',
        quantitySelect: '选择数量',
        quantitySelectLabel: '数量',
        soldOut: '售罄',
        total: '合计'
      },
      planCard: {
        tip: '预定贩售当日票'
      },
      planDetailDialog: {
        title: '方案详情',
        planContent: '方案内容',
        meetingPlace: '集合地点',
        cancellationPolicy: '取消政策'
      },
      priceTableDialog: {
        notes: {
          agePolicy: `5岁以下是免费的，6岁未入学校的儿童也是免费的。15岁以下是学生，适用儿童票价，18岁以上是高中生，适用青少年票价。`
        }
      },
      payment: {
        ticket: '门票',
        option: '附加商品',
        total: '合计（含税）',
        details: '详情',
        submit: '去下单'
      },
      bookingInfo: {
        plan: '套餐',
        dateTime: '日期时间',
        ticket: '门票',
        option: '附加商品',
        discount: '折扣',
        total: '支付金额（含税）'
      }
    },
    home: {
      title: '东京晴空塔',
      header: {
        alt: '东京晴空塔'
      },
      search: {
        placeholder: '搜索商品'
      },
      ticketList: {
        title: '票券一览'
      },
      enjoyPack: {
        title: '畅游套餐'
      }
    },
    faq: {
      title: '常见问题',
      purchase: {
        title: '购票相关',
        q1: '无法使用信用卡完成支付',
        a1: `test如果支付页面无法顺利完成，请确认以下事项：

1）网络状况
・可能由于网络暂时不稳定或高峰时段访问量过大，导致支付中断。
・请先关闭页面，稍作等待后，在网络信号良好的环境下重新尝试支付。

2）信用卡使用状况及 3D 安全验证
・请确认所使用信用卡的有效期和额度是否正常。
・请确认所使用的信用卡是否支持“3D 安全验证（3D Secure）”。
自2025年4月起，在线购票时必须启用 3D 安全验证。
因此，东京晴空塔预约网站仅支持已设置 3D 安全验证的信用卡完成支付。

3）信用卡公司安全系统触发
・即使信用卡本身正常，仍可能因信用卡公司安全系统触发而导致支付中断。
・建议联系信用卡公司进行确认。

如需进一步确认支付状态，请通过此表单联系我们。
https://veltra.zendesk.com/hc/zh-cn/requests/new?ticket_form_id=53455569113241`,
        q2: '日历上希望选择的日期显示“×”，无法预约',
        a2: `＜东京晴空塔观景台及空中回廊门票＞
・门票自使用日前约 2 个月起开始发售，日历将按顺序开放。
・发售开始后，如果在购票页面的日历中无法选择所选日期或时段，则表示该场次已售罄。
如所选日期或时段无空余，建议选择前后日期的其他场次。

▼购票页面
https://global-official-ticket.tokyo-skytree.jp/zh/home

※在线购票可持续至入园当日，但在大型连休等期间，门票可能会提前售罄。
※在线购票价格通常比现场窗口票更优惠，建议提前购买。

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 自使用日前约 1 个月起开始发售，可在使用日前一天之前完成购买（当天不售票）。`,
        q3: '门票何时开始发售？',
        a3: `＜东京晴空塔观景台及空中回廊门票＞
・门票自使用日前约 2 个月起开始发售，日历将按顺序开放。
・在线购票可持续至入园当日，但在大型连休等期间，门票可能会提前售罄。

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 自使用日前约 1 个月起开始发售，可在使用日前一天之前完成购买（当天不售票）。

※对于隅田川烟花大会或元旦等特殊营业日的门票，发售时间可能有所不同。详细信息将在活动日期临近时，通过东京晴空塔官方网站发布。`,
        q4: '在线购票可使用哪些支付方式？',
        a4: `可使用的支付方式包括：信用卡（VISA、MasterCard、AMEX、JCB、Diners）、借记卡，以及支付宝（Alipay）、微信支付（WeChat Pay）。`,
        q5: '是否提供当日票？现场一定能买到吗？',
        a5: `＜东京晴空塔观景台及空中回廊门票＞
・没有“当日票”的专门额度。门票仅在库存充足时，从预约发售至入园当日均可购买。
・无论是在线购票还是现场窗口售票，当日仅在库存充足的情况下可购买。若某日期已提前售罄，当日不会追加销售。
・在大型连休等期间，门票可能会提前售罄。
・在线购票价格通常比现场窗口票更优惠，建议提前购买。
・最新销售状况请通过下方销售页面确认：

▼购票页面
https://global-official-ticket.tokyo-skytree.jp/zh/home

＜晴空塔 Enjoy Pack＞
・Enjoy Pack 当天不售票，请在使用日前一天之前完成购买。`,
        q6: '孩子刚初中毕业、尚未入读高中，应购买哪种票？',
        a6: `入园当日未满 15 岁的游客适用儿童票，16 岁及以上的游客适用成人票。`,
        q7: '购票是否必须注册会员？',
        a7: `购买东京晴空塔门票前，请先完成会员注册。
如无法登录，请参考以下说明页面：

▼ 若无法登录
请查阅 FAQ 中的「无法登录账号」相关说明。`,
        q8: '“Enjoy Pack”可享受残障人士优惠吗？',
        a8: `“ENJOY PACK”套票已包含优惠折扣，价格已属优惠方案，无法再享受残障人士相关优惠。`,
        q9: '设施、设备及停车场相关信息',
        a9: `有关设施、设备、停车场、团体预约及团体停车场等信息，请访问东京晴空塔官方网站的「常见问题」页面查询。

▼ 东京晴空塔官方网站 – 设施与设备相关问题
https://www.tokyo-skytree.jp/cn_s/faq/

▼ 东京晴空塔官方网站 – 团体预约相关说明
https://www.tokyo-skytree.jp/ticket/group/general/`
      },
      late: {
        title: '可能赶不上入园时间或者迟到入园与入场安排',
        q1: '万一赶不上预约时间，可以入园吗？',
        a1: `原则上，请按照购票时指定的入园时段入园。
如因个人原因导致迟到，仅持有「指定日期与时段票券」的游客，可在指定当日按照现场指示，到队伍末尾排队入园。
将根据现场情况依序引导入园，但视当日人流情况，可能需要等待较长时间，敬请谅解。
※ 本票券仅限指定使用当日有效，逾期无法使用，也不提供退款，请注意。

当日营业时间请参考东京晴空塔官方网站公告：

▼ 营业时间表
https://www.tokyo-skytree.jp/open-hours/`
      },
      conditions: {
        title: '当日观景体验及人流情况',
        q1: '当日观景体验及景色情况',
        a1: `由于观景视野会随时间及天气状况变化，即使联系客服，也无法提供实时景观信息，敬请谅解。建议提前参考东京地区天气预报进行评估。
此外，因雨天、多云等天气因素导致视线不佳，不提供退票或部分退款服务。

如需取消订单，请先登录「我的页面」确认相关取消规定及手续费后，再进行操作。

▼ 登录我的页面
https://global-official-ticket.tokyo-skytree.jp/zh/booking`,
        q2: '当日人流拥挤情况',
        a2: `东京晴空塔官方网站首页提供人流预测信息，供游客参考。

・根据现场人流情况，电梯可能会出现排队等待，请注意，致电客服无法提供实时等待情况。
・请预留足够时间前往。
・观景台入场后没有停留时间限制，但在极少数情况下，受当日人流或电梯运行影响，工作人员可能会进行引导。

▼ 东京晴空塔官方网站 – 人流预测
https://www.tokyo-skytree.jp/cn_s/ticket/congestion/`
      },
      email: {
        title: '未收到预约确认邮件',
        q1: '未收到预约确认邮件',
        a1: `预约时注册的邮箱会自动收到主题为「预约已确认（预约编号：ARS_SKYTREE-XXXX-XXXX）」的邮件，请及时查收。

・预约确认邮件由「@linktivity.co.jp」域名发送。
・请同时检查垃圾邮件或垃圾箱文件夹。
・如果使用平时不常用的邮箱注册，也请确认其他可能的邮箱收件箱。

如仍未收到邮件，请登录个人页面确认预约状态。
▼ 个人页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

※ 若通过东京晴空塔官方网站以外的在线旅行社购票，请联系对应旅行社确认预约情况。

▼ 若无法登录
请查阅 FAQ 中的「无法登录账号」相关说明。`
      },
      use: {
        title: '门票使用方法及二维码显示',
        q1: '已完成支付，但找不到门票',
        a1: `入园当天所需的凭证（含 QR Code 链接），可在会员「我的页面」或预约确认邮件中查看。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

▼ 关于预约确认邮件，请确认以下事项：
・发件人域名为「@linktivity.co.jp」。
・邮件可能被归类至垃圾邮件或已删除邮件文件夹。
・您也可能使用平时较少使用的邮箱地址进行注册。
→ 请一并确认是否使用其他相关邮箱注册会员，并检查对应邮箱的收件箱。

▼ 若无法登录
请查阅 FAQ 中的「无法登录账号」相关说明。

＊ 若通过东京晴空塔官方网站以外的旅游平台购票，请直接联系原购票平台处理。
*QR Code 为株式会社 DENSO WAVE 的注册商标。`,
        q2: '二维码无法在手机屏幕上正常显示',
        a2: `入园当天所需的凭证链接，可在会员「我的页面」或预约确认邮件中查看。
・如果在移动设备上 QR Code 无法正常显示，请先关闭页面，并在网络信号良好的环境下重新打开。
・入园时需出示 QR Code，建议提前确认页面可正常显示，也可截图备份。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

▼ 若无法登录
请查阅 FAQ 中的「无法登录账号」相关说明。

＊ 若通过东京晴空塔官方网站以外的线上旅游平台购票，请直接联系原购票平台。
*QR Code 为株式会社 DENSO WAVE 的注册商标。`,
        q3: '无法登录账号',
        a3: `无法登录时，请按照以下方式确认：

1）确认登录邮箱
・请确认是否使用注册时填写的正确邮箱登录。
・如果平时不常使用该邮箱，也请尝试其他可能使用过的邮箱。

2）确认登录方式
・请使用与注册时相同的登录方式。
・如果当初使用 Gmail 注册，请确认是通过「Google 登录」还是「邮箱登录」注册。
・如忘记密码，请在登录页面点击「忘记密码」重新设置。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

＊ 若通过东京晴空塔官方网站以外的线上旅游平台购票，请直接联系原购票平台处理相关事宜。`,
        q4: '不小心删除了预约确认邮件，该怎么办？',
        a4: `可通过以下任一方式查看凭证或二维码：

1）通过「我的页面」查询预约信息
登录「我的页面」 → 点击右上角人形图标 → 选择「我的页面」→ 点击「预约信息」→ 显示预约列表 → 进入预约详细页面，即可查看电子凭证。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

2）通过「我的页面」重新发送电子凭证
登录「我的页面」 → 点击右上角人形图标 → 选择「我的页面」→ 点击「预约信息」→ 显示预约列表 → 进入预约详细页面 → 点击「发送电子凭证」按钮，即可将含票券链接的电子凭证重新发送至指定邮箱。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

＊ 若通过东京晴空塔官方网站以外的线上旅游平台购票，请直接联系原购票平台处理相关事宜。`,
        q5: '账户已删除，无法登录个人中心，门票还能使用吗？',
        a5: `只要未取消预约，您的预约（门票）仍然有效，可正常使用。
可通过预约确认邮件查看含门票链接的电子凭证。`,
        q6: '可以打印电子凭证并携带入园吗？',
        a6: `QR Code 可打印在纸质票上使用，也可通过截图或移动设备屏幕出示。
打印时，请务必确保 QR Code 清晰可辨，以免影响入场。

*QR Code 为株式会社 DENSO WAVE 的注册商标。`,
        q7: '进入观景台后是否有停留时间限制？',
        a7: `入场后，不设停留时间限制。`,
        q8: '可以提前取票吗？',
        a8: `自 2026 年 3 月 2 日起，票务系统已完成改版，入场时无需另行兑换实体票。
请在入场时打开凭证链接，出示屏幕上的 QR Code，于入口处扫码即可进入东京晴空塔参观。
*QR Code 为株式会社 DENSO WAVE 的注册商标。`,
        q9: '提前到达能在预约时间前入园吗？',
        a9: `不提供提前入场服务，请按照购票时指定的入场时段入场，敬请配合。`,
        q10: '可以再次入园吗？',
        a10: `入场后一旦离场，将无法再次入场，请您注意。`
      },
      changes: {
        title: '门票变更与取消规则',
        q1: '可以更改入园日期、时间或人数吗？',
        a1: `非常抱歉，入场日期、时间或人数无法变更。如需调整预约内容，请先取消原订单，再根据需求重新购票。
・若预约时间可能迟到，当日仅可依现场指示至队伍尾端排队入场，可能需等待较长时间。
・取消订单将依取消政策收取相应费用，请事先于「我的页面」确认取消规则及手续费。
・为避免操作错误，不接受通过电话或电子邮件办理取消。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

本规定适用于东京晴空塔相关票券，实际内容请以官方公告为准。`,
        q2: '观景台门票可以升级为包含空中回廊的套票吗？',
        a2: `非常抱歉，购票完成后无法升级或更改为展望回廊套票。
如有需要，可在地上 350 米天望台的现场售票机购买天望回廊入场券；但在人流较多时，可能会暂时停止售卖，敬请谅解。

本规定适用于东京晴空塔相关票券，实际销售状况请以现场公告为准。`,
        q3: '可以取消预约吗？',
        a3: `各票种的取消政策可能不同，如需取消订单，请先登录「我的页面」确认相关规定及手续费后，自行完成取消操作。
・取消时，将依规定收取相应的取消费用。
・为避免操作错误，不接受通过电话或电子邮件提出的取消申请，敬请谅解。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

本规定适用于东京晴空塔相关票券，实际内容请以官方公告为准。`,
        q4: '“Enjoy Pack”中包含的某项设施未使用，可以退款吗？',
        a4: `若因个人原因未使用套票内的部分设施，恕不提供退款，敬请留意。`,
        q5: '误购买了错误的门票类型或日期时间，该怎么办？',
        a5: `非常抱歉，入场日期、时间或人数无法变更。如需调整预约内容，请先取消原订单，再根据需求重新购票。
・若预约时间可能迟到，当日仅可依现场指示至队伍尾端排队入场，可能需等待较长时间。
・取消订单将依取消政策收取相应费用，请事先于「我的页面」确认取消规定及手续费。
・为避免操作错误，不接受通过电话或电子邮件办理取消。

▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

本规定适用于东京晴空塔相关票券，实际内容请以官方公告为准。`,
        q6: '因自然灾害、交通停运或传染病等原因无法前往，可以取消吗？',
        a6: `除非因臨時閉館等特殊狀況，恕不受理基於個人原因之取消申請。臨時閉館資訊將公告於東京晴空塔官方網站。
・若因交通工具預計停駛等因素需取消訂單，請先於「我的頁面」確認取消政策及相關費用後，自行完成取消手續。
・為避免作業錯誤，恕不受理透過電話辦理取消，敬請見諒。

▼ 我的頁面登入
https://global-official-ticket.tokyo-skytree.jp/zh/booking

▼ 東京晴空塔官方網站
https://www.tokyo-skytree.jp/cn_s/`,
        q7: '因强风导致电梯暂停运行，是否可以退款？',
        a7: `为了保障游客安全，如遇高空恶劣天气或大风等情况，观景台电梯可能会临时停运，敬请理解。
最新运行信息请以东京晴空塔官网公告为准。

关于恢复运行时间及退票事宜，请以现场公告为准，并向现场工作人员咨询。

▼ 东京晴空塔官网
https://www.tokyo-skytree.jp/cn_s/`
      },
      payment: {
        title: '支付相关',
        q1: '似乎被信用卡重复扣款，该怎么办？',
        a1: `请先登录“我的页面”确认订单预约状态。
若仅显示一笔订单记录，另一笔可能仅为信用卡使用通知，实际尚未完成扣款。

▼ 登录我的页面
https://global-official-ticket.tokyo-skytree.jp/zh/booking

如需进一步确认付款状态，请通过以下表单联系客服查询。
https://veltra.zendesk.com/hc/zh-cn/requests/new?ticket_form_id=53455569113241
※本说明适用于东京晴空塔相关门票的付款与订单查询，实际处理结果以系统及客服回复为准。`,
        q2: '系统显示支付失败，该如何处理？',
        a2: `请先登录“我的页面”确认是否已成功完成预约。
若未显示任何预约信息，表示订单尚未成立，请在确认以下事项后重新购票。

▼ 登录我的页面
https://global-official-ticket.tokyo-skytree.jp/zh/booking

常见原因说明：
1）网络连接状况
・可能因网络短暂不稳定，或同一时段订单量较大，导致连接或支付中断。
・请先关闭页面，稍作等待后，在网络信号良好的环境下重新操作。

2）信用卡使用状况与 3D 验证
・请确认信用卡有效期及可用额度是否正常。
・请确认信用卡是否已开通“3D 验证（3D Secure）”服务。
・自 2025 年 4 月起，在线购票需启用 3D 验证功能，东京晴空塔官方购票系统仅接受已完成设置的信用卡付款。

3）信用卡银行安全机制
・即使信用卡本身无异常仍无法完成支付，可能为发卡银行触发安全机制所致。
・建议稍后尝试其他信用卡，或联系发卡银行确认相关状况。

如需详细确认支付及预约状态，请通过此表单联系我们。
https://veltra.zendesk.com/hc/zh-cn/requests/new?ticket_form_id=53455569113241`,
        q3: '已收到信用卡消费通知，但个人中心没有预约信息，也未收到确认邮件',
        a3: `若在“我的页面”中未显示预约信息，可能存在以下情况：

1）使用不常用的电子邮箱注册
・请确认是否使用其他电子邮箱注册过账户。
・同时检查各邮箱的收件箱及垃圾邮件文件夹，并尝试登录“我的页面”查看预约信息。

▼ 登录我的页面
URL

2）使用 Google 账号注册，但登录方式不一致
・请务必使用与预约时相同的登录方式：
・预约时选择“邮箱登录”，请使用“邮箱登录”。
・预约时选择“Google 登录”，请使用“Google 登录”。

3）支付或预约未完成
・即使已完成信用卡额度验证，也可能因网络不稳定等原因导致支付或预约未成功。
・请确认信用卡账单是否有实际扣款记录。

如需进一步确认支付及预约状态，请通过此表单联系我们。
https://veltra.zendesk.com/hc/zh-cn/requests/new?ticket_form_id=53455569113241`,
        q4: '已取消预约，退款何时到账？',
        a4: `若您已完成取消操作但尚未收到退款，可能因信用卡公司处理流程需要时间，建议先向发卡银行确认入账情况。
如需进一步查询退款进度，请通过此表单联系我们。
https://veltra.zendesk.com/hc/zh-cn/requests/new?ticket_form_id=53455569113241
※本说明适用于东京晴空塔相关票券的退款处理规范，实际处理情况以系统及客服回复为准。`,
        q5: '可以开具发票或收据吗？',
        a5: `1）通过东京晴空塔官方网站购票
・发票可在「我的页面」或预约确认邮件中点击「发票」按钮自行开具。
・开具后，系统将由 linktivity.co.jp 发送「发票发送通知」电子邮件，请同时检查垃圾邮件或垃圾箱。
▼ 我的页面登录
https://global-official-ticket.tokyo-skytree.jp/zh/booking

2）团体预约
・团体预约相关发票请参考以下专用页面办理：
▼ 东京晴空塔官方网站 – 团体预约页面
https://www.tokyo-skytree.jp/ticket/group/general/

3）当日现场购票
・无法在线开具发票，请至现场窗口咨询相关操作。
▼ 东京晴空塔官方网站
https://www.tokyo-skytree.jp/cn_s/`
      },
      disabilities: {
        title: '残障人士及陪同服务说明',
        q1: '残障人士及陪同服务说明',
        a1: `适用条件

持有残障者手册者及其陪同者可适用残障者票价。
陪同者票券可购买与手册持有者相同人数。
入场时需出示残障者手册，请务必携带。


通常票价的变更
如以通常票价购买票券，无法变更至残障者票价。
如需变更，请先取消当前预约，再重新购买所需票券。
▼ 取消方法请参考此处
https://global-official-ticket.tokyo-skytree.jp/zh/booking`
      },
      group: {
        title: '团体预约及专用窗口',
        q1: '团体预约及专用窗口',
        a1: `团体预约请通过东京晴空塔专用窗口办理。
请前往官方「联系我们」页面，查看「联系方式一览」获取详细信息。

▼ 东京晴空塔官方网站 – 团体预约专用窗口
https://www.tokyo-skytree.jp/inquiry/`
      },
      tips: `客服邮箱：<a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
关于线上购买的电话咨询：<a href="tel:+81368217196">+81-3-6821-7196</a>
※来电咨询时，将先通过自动语音系统进行说明，并根据您的咨询内容转接至相应的客服人员。
※拨打电话将根据运营商规定收取通话费用。
人工客服服务时间：10:00～19:00`
    }
  }
};
